var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-4 w-4",attrs:{"fill":"currentColor","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"}}),_c('path',{attrs:{"d":"M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }